export const ROUTES = {
  HOME: '/planning',
  PLANNING: '/planning',
  INSPECTOR_MANAGEMENT: '/inspector',
  CONFIGURATION: '/configuration',
  SIZE_CHARTS_IMPORTS: '/size-charts-imports',
  MASTER_DATA: '/master-data',
  MASTER_DATA_FACTORIES: '/master-data/factories',
  MASTER_DATA_SUPPLIERS: '/master-data/suppliers',
  MASTER_DATA_CUSTOMERS: '/master-data/customers',
  MASTER_DATA_FACTORIES_BULK_CREATE: '/master-data/factories/bulk-create',
  INSPECTION_DETAIL: '/planning/inspections',
  LOGIN: '/',
  ERROR: '/error',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '*',
} as const;

export function inspectionDetailPath(id: string): string {
  return `${ROUTES.INSPECTION_DETAIL}/${id}`;
}

/** Path segment under `/planning/inspections/:id/report/download` (Power BI / secured download). */
export const INSPECTION_REPORT_DOWNLOAD = 'report/download' as const;

export function inspectionReportDownloadPath(
  id: string,
  type: 'full' | 'summary' = 'full'
): string {
  const base = `${ROUTES.INSPECTION_DETAIL}/${id}/${INSPECTION_REPORT_DOWNLOAD}`;
  if (type === 'full') {
    return base;
  }
  return `${base}?type=${type}`;
}

export function isInspectionReportDownloadPath(path: string): boolean {
  const pathname = path.split('?')[0] ?? '';
  return /^\/planning\/inspections\/[^/]+\/report\/download\/?$/.test(pathname);
}

export const PLANNING_TABS = {
  LIST: 'list',
  CALENDAR: 'calendar',
  WEEKLY_PLAN: 'weekly-plan',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];
export type PlanningTabValue = (typeof PLANNING_TABS)[keyof typeof PLANNING_TABS];
